"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var column_category_dto_1 = require("../dto/column-category-dto");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * Column branch builder allowing to make sub-branches by adding categories.
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var ColumnCategoryBuilder = /** @class */ (function () {
    function ColumnCategoryBuilder(categoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPathHolderId);
        this._element = new column_category_dto_1.ColumnCategoryDto();
        this._element.categoryElementDto.categoryPathHolderId = categoryPathHolderId;
    }
    ColumnCategoryBuilder.prototype.getElement = function () {
        return this._element;
    };
    ColumnCategoryBuilder.prototype.addColumnCategory = function (categoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPathHolderId);
        var child = new ColumnCategoryBuilder(categoryPathHolderId);
        this._element.children.push(child._element);
        return child;
    };
    ColumnCategoryBuilder.prototype.setTotalType = function (totalType) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(totalType);
        this._element.categoryElementDto.totalType = totalType;
        return this;
    };
    ColumnCategoryBuilder.prototype.setTopCount = function (topCount) {
        this._element.categoryElementDto.topCount = topCount;
        return this;
    };
    ColumnCategoryBuilder.prototype.setOtherType = function (otherType) {
        this._element.categoryElementDto.otherType = otherType;
        return this;
    };
    ColumnCategoryBuilder.prototype.setOrderType = function (orderType) {
        this._element.orderType = orderType;
        return this;
    };
    ColumnCategoryBuilder.prototype.setShowAsType = function (showAsType) {
        this._element.categoryElementDto.showAsType = showAsType;
        return this;
    };
    ColumnCategoryBuilder.prototype.setFilter = function (filter) {
        this._element.filterTreeDto = filter;
        return this;
    };
    ColumnCategoryBuilder.prototype.setShowOnRowsTotal = function (showOnRowsTotal) {
        this._element.showOnRowsTotal = showOnRowsTotal;
        return this;
    };
    ColumnCategoryBuilder.prototype.setSortMeasurePathHolderId = function (sortMeasurePathHolderId) {
        this._element.categoryElementDto.sortMeasurePathHolderId = sortMeasurePathHolderId;
        return this;
    };
    return ColumnCategoryBuilder;
}());
exports.ColumnCategoryBuilder = ColumnCategoryBuilder;
//# sourceMappingURL=column-category-builder.js.map